import { forwardRef } from 'react';
import { Grid as MUIGrid } from '@mui/material';
import type { GridProps as MUIGridProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import {
  unstable_extendSxProp as extendSxProp,
  type SystemProps,
} from '@mui/system';

// MUI v9 (Grid v2) removed system style props (my, flex, textAlign, etc.) from
// Grid in favour of the `sx` prop. We keep the old ergonomics by accepting
// system props and folding them into `sx` at runtime via `extendSxProp`.
export type GridProps = MUIGridProps & SystemProps<Theme>;

export const Grid = forwardRef<HTMLDivElement, GridProps>(
  function Grid(props, ref) {
    return <MUIGrid ref={ref} {...extendSxProp(props)} />;
  },
);
